
import styles from './Footer.module.css'

const Footer = () => {
    const data = new Date()
    const year = data.getFullYear()
    return(
        <footer className={styles.footer}>
            <p className={styles.text}>
                &copy; {year} David Bogomolov | All rights reserved
            </p>
        </footer>
    )
}

export default Footer